<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary400 } = $AppState.theme.colors;

  export let stroke: string = primary400;
</script>

<svg
  class="twism-dashed-circle {$$props.class || ''}"
  width="314"
  height="2"
  viewBox="0 0 314 2"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    opacity="0.6"
    d="M1 1L313 1.00003"
    stroke={primary400}
    stroke-width="2"
    stroke-linecap="round"
    stroke-dasharray="0.1 6"
  />
</svg>

<style lang="scss">
  .twism-dashed-circle {
    width: 100% !important;
  }
</style>
